export default __webpack_public_path__ + "static/media/screenshot2.356872e6.jpg";